import { render, staticRenderFns } from "./ContextSettings.Preprocessors.vue?vue&type=template&id=1b48a94e&scoped=true&"
import script from "./ContextSettings.Preprocessors.vue?vue&type=script&lang=ts&"
export * from "./ContextSettings.Preprocessors.vue?vue&type=script&lang=ts&"
import style0 from "./ContextSettings.Preprocessors.vue?vue&type=style&index=0&id=1b48a94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48a94e",
  null
  
)

export default component.exports